import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "./index.scss";

const Terminos = () => {
  return (
    <div className="terminos-container">
      <Header variant="dark" />
      <div className="content">
        <p className="title-one">TÉRMINOS Y CONDICIONES DE USO DE LA PLATAFORMA "PITAGE"</p>
        <p className="update-date">Fecha de última actualización: 20/04/2026</p>

        <p className="title-two">1. Identificación del titular de la Plataforma</p>
        <p>La aplicación móvil PITAGE (en adelante, la “Plataforma”) es una plataforma a través de la cual se ofrecen los servicios descritos en los presentes Términos y Condiciones.</p>
        <p>Toda referencia a PITAGE en los presentes Términos y Condiciones deberá entenderse realizada a la Plataforma.</p>
        <p className="title-two">2. Aceptación</p>
        <p>
          Los presentes Términos y Condiciones (en adelante, el "Acuerdo") regulan el acceso, registro y uso de la Plataforma.
        </p>
        <p>
          El acceso, registro y/o uso de la Plataforma implica la aceptación expresa, plena y sin reservas del presente Acuerdo. Si el Usuario no estuviera de acuerdo con cualquiera de sus disposiciones, deberá abstenerse de utilizar la Plataforma.
        </p>

        <p className="title-two">3. Titularidad y actividad</p>
        <p>La Plataforma es operada por Trustigo S.A., bajo un modelo de financiamiento con fondos propios.</p>
        <p>La operatoria de la Plataforma:</p>
        <p className="bullet">Se encuadra como Proveedor No Financiero de Crédito (PNFC).</p>
        <p className="bullet">No constituye una entidad financiera.</p>
        <p className="bullet">No capta depósitos del público.</p>
        <p className="bullet">No realiza intermediación financiera.</p>

        <p className="title-two">4. Objeto de la Plataforma</p>
        <p>La Plataforma permite a los Usuarios:</p>
        <p className="bullet">Registrarse y crear una cuenta.</p>
        <p className="bullet">Solicitar productos de financiamiento.</p>
        <p className="bullet">Gestionar solicitudes.</p>
        <p className="bullet">Consultar información relacionada con sus operaciones.</p>
        <p className="bullet">Realizar pagos y cancelaciones.</p>
        <p>El acceso a los servicios ofrecidos estará sujeto a la evaluación previa realizada por la Plataforma.</p>

        <p className="title-two">5. Registro del Usuario</p>
        <p>Para utilizar la Plataforma, el Usuario deberá:</p>
        <p className="bullet">Ser mayor de dieciocho (18) años.</p>
        <p className="bullet">Proporcionar información veraz, completa y actualizada.</p>
        <p className="bullet">Validar su identidad mediante los mecanismos establecidos por la Plataforma.</p>
        <p>El Usuario será responsable de:</p>
        <p className="bullet">La veracidad de la información proporcionada.</p>
        <p className="bullet">La confidencialidad y el uso de sus credenciales de acceso.</p>
        <p>
          La Plataforma podrá rechazar solicitudes de registro cuando detecte inconsistencias, información insuficiente o riesgos asociados.
        </p>

        <p className="title-two">6. Evaluación y análisis de información</p>
        <p>
          La Plataforma podrá analizar la información proporcionada por el Usuario y consultar fuentes de información legalmente disponibles para evaluar las solicitudes presentadas.
        </p>
        <p>
          La aprobación o rechazo de cualquier solicitud será determinada exclusivamente por la Plataforma conforme a sus políticas internas de evaluación.
        </p>

        <p className="title-two">7. Condiciones de los productos</p>
        <p>Antes de confirmar cualquier operación, la Plataforma informará al Usuario las condiciones aplicables, incluyendo, entre otras:</p>
        <p className="bullet">Monto solicitado.</p>
        <p className="bullet">Monto a desembolsar.</p>
        <p className="bullet">Costos aplicables.</p>
        <p className="bullet">Plazo.</p>
        <p className="bullet">Monto total a pagar.</p>
        <p>
          La confirmación de la operación implicará que el Usuario declara haber leído, comprendido y aceptado dichas condiciones.
        </p>

        <p className="title-two">8. Estructura de costos y transparencia</p>
        <p>El Usuario reconoce y acepta que:</p>
        <p className="bullet">El monto efectivamente desembolsado podrá diferir del monto total de la obligación asumida.</p>
        <p className="bullet">Los costos del servicio podrán incluir cargos administrativos, operativos, financieros u otros conceptos debidamente informados.</p>
        <p className="bullet">El monto total a pagar será informado previamente de forma clara y transparente.</p>
        <p>
          Antes de aceptar cualquier operación, la Plataforma pondrá a disposición del Usuario un resumen completo con las condiciones aplicables.
        </p>

        <p className="title-two">9. Pagos y mora</p>
        <p>El Usuario se obliga a cumplir con los pagos en las fechas y condiciones pactadas.</p>
        <p>En caso de mora:</p>
        <p className="bullet">Podrán aplicarse los cargos adicionales permitidos por la normativa vigente.</p>
        <p className="bullet">Podrán iniciarse las correspondientes gestiones de cobranza.</p>
        <p>Dichas gestiones se realizarán respetando la normativa aplicable y los principios de trato digno al consumidor.</p>

        <p className="title-two">10. Pagos realizados por terceros</p>
        <p>La Plataforma podrá permitir que determinadas obligaciones sean canceladas por terceros en representación del Usuario.</p>
        <p>En tales casos:</p>
        <p className="bullet">El Usuario autoriza la realización de dichos pagos.</p>
        <p className="bullet">La Plataforma podrá aplicar mecanismos de validación adicionales.</p>
        <p className="bullet">La Plataforma podrá solicitar información complementaria respecto del tercero que efectúe el pago.</p>
        <p className="bullet">La Plataforma no será responsable por errores o inconvenientes derivados de pagos efectuados incorrectamente por terceros.</p>

        <p className="title-two">11. Uso de la Plataforma</p>
        <p>El Usuario se compromete a:</p>
        <p className="bullet">Utilizar la Plataforma de forma lícita y conforme a la legislación vigente.</p>
        <p className="bullet">No realizar actividades fraudulentas o ilícitas.</p>
        <p className="bullet">No vulnerar la seguridad, integridad o funcionamiento de la Plataforma.</p>
        <p>La Plataforma podrá suspender o cancelar el acceso del Usuario cuando detecte incumplimientos de estos Términos y Condiciones.</p>

        <p className="title-two">12. Protección de datos personales</p>
        <p>
          El tratamiento de los datos personales se realizará conforme a la Política de Privacidad de la Plataforma y a la Ley N.º 25.326 de Protección de los Datos Personales y demás normativa aplicable.
        </p>

        <p className="title-two">13. Prevención de lavado de activos</p>
        <p>La Plataforma podrá:</p>
        <p className="bullet">Solicitar información o documentación adicional.</p>
        <p className="bullet">Verificar la identidad del Usuario.</p>
        <p className="bullet">Reportar operaciones sospechosas cuando corresponda conforme a la normativa vigente.</p>

        <p className="title-two">14. Responsabilidad</p>
        <p>
          La Plataforma procurará mantener la disponibilidad y el correcto funcionamiento de sus servicios; sin embargo, no garantiza su disponibilidad continua o ininterrumpida.
        </p>
        <p>En consecuencia, no será responsable por daños derivados de:</p>
        <p className="bullet">Fallas técnicas ajenas a su control.</p>
        <p className="bullet">Uso indebido de la Plataforma por parte del Usuario.</p>
        <p className="bullet">Casos fortuitos o de fuerza mayor.</p>

        <p className="title-two">15. Modificaciones</p>
        <p>La Plataforma podrá modificar los presentes Términos y Condiciones en cualquier momento.</p>
        <p>Las modificaciones entrarán en vigor desde su publicación en la Plataforma, salvo disposición legal en contrario.</p>

        <p className="title-two">16. Terminación</p>
        <p>La Plataforma podrá suspender o cancelar el acceso del Usuario cuando se verifique cualquiera de las siguientes circunstancias:</p>
        <p className="bullet">Incumplimiento de los presentes Términos y Condiciones.</p>
        <p className="bullet">Existencia de riesgos legales o regulatorios.</p>
        <p className="bullet">Uso indebido o fraudulento de la Plataforma.</p>

        <p className="title-two">17. Jurisdicción y ley aplicable</p>
        <p>Los presentes Términos y Condiciones se regirán por las leyes de la República Argentina.</p>
        <p>
          Toda controversia derivada de su interpretación o ejecución será resuelta conforme a la legislación vigente, incluyendo las normas de protección y defensa de los consumidores y usuarios.
        </p>

        <p className="title-two">18. Canales de contacto</p>
        <p>
          El Usuario podrá comunicarse con la Plataforma a través de los canales oficiales de atención publicados en la aplicación o escribe un correo al pitage.informacion@gmail.com.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default Terminos;
